import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { RouterProvider } from 'react-router'
import { ApiProvider, type ApiConfig, createQueryClient } from '@m3-tech/boss-api'
import { AUTH_TOKEN_COOKIE, GlobalStateProvider } from '@m3-tech/boss-core'
import { ErrorBoundary } from '@m3-tech/boss-ui'
import { getCookie, deleteCookie } from '@m3-tech/boss-utils'
import { AuthWrapper } from './components/AuthWrapper'
import { router } from './core/routes'

const queryClient = createQueryClient()

const cookieDomain: string | undefined = import.meta.env.VITE_COOKIE_DOMAIN || undefined

const apiConfig: ApiConfig = {
    baseUrl: import.meta.env.VITE_API_URL,
    loginUrl: import.meta.env.VITE_LOGIN_URL,
    isMockEnabled: import.meta.env.VITE_ENABLE_MSW === 'true',
    cookieDomain,
    getHeaders: () => {
        const headers: Record<string, string> = {
            'X-Module-WebApp': import.meta.env.VITE_MODULE_NAME ?? 'Communications',
            'X-Module-Env': import.meta.env.VITE_NODE_ENV,
        }
        const token = getCookie(AUTH_TOKEN_COOKIE)
        if (token) {
            headers['Authtoken'] = token
        }
        return headers
    },
    onUnauthorized: () => {
        deleteCookie(AUTH_TOKEN_COOKIE, '/', cookieDomain)
        if (cookieDomain) {
            deleteCookie(AUTH_TOKEN_COOKIE)
        }
        window.location.href = import.meta.env.VITE_LOGIN_URL
    },
}

function App() {
    return (
        <ErrorBoundary>
            <ApiProvider config={apiConfig} queryClient={queryClient}>
                <GlobalStateProvider>
                    <AuthWrapper>
                        <RouterProvider router={router} />
                    </AuthWrapper>
                </GlobalStateProvider>
                <ReactQueryDevtools initialIsOpen={false} />
            </ApiProvider>
        </ErrorBoundary>
    )
}

export default App
